import { render } from "./mobilemenu.vue?vue&type=template&id=030053c2"
import script from "./mobilemenu.vue?vue&type=script&lang=js"
export * from "./mobilemenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__